<div class="stats">
  <div
    class="stats-header"
    [class.fade]="pillExpanded"
  >
    <a class="stats-header-back back-button" (click)="goBack()">
      <i class="fa-solid fa-chevron-left"></i>
      <div class="back text">{{ 'WebApp.v1.Shared.Buttons.Back' | translate }}</div>
    </a>

    <div class="stats-header-logo">
      <img
        [src]="companyLogo()"
        (error)="getHowdyLogo()"
        [class.not-howdy]="!isHowdyLogo"
        class="logo"
        alt="logo"
      >
        <p class="text">{{ 'WebApp.v1.Shared.AwarenessByHowdy' | translate }}</p>
    </div>
  </div>

  <div class="stats-content">
    <div class="stats-content-action">
      <app-pill
        class="stats-content-action-pill"
        [class.expanded]="pillExpanded"
      >
        <app-feature-pill-menu
          class="pill-menu"
          (expandedChange)="pillExpanded = $event"
          (menuItemChange)="onMenuItemChange($event)"
        ></app-feature-pill-menu>
      </app-pill>
      <app-button class="stats-content-action-button"
        [iconLeft]="buttonIcon"
        [label]="buttonText | translate"
        [fontSize]="24"
        backgroundColor="rgba(87, 223, 142, 0.97)"
        (click)="goToNextSurvey()"
      >
        <video
          class="stats-content-action-button-video"
          src="{{s3BaseUrl}}assets/videos/water.mp4"
          autoplay
          muted
          loop
          playsinline
          webkit-playsinline
          class="stats-content-action-button-video"
        ></video>
      </app-button>
    </div>
    <div class="stats-content-date-picker">
      <app-date-picker
        [color]="primaryColor"
        [highlightedDates]="highlightedDates"
        [date]="selectedDate"
        [disabled]="!highlightedDates || highlightedDates.length === 0"
        (dateSelected)="selectedDateChanged($event)"
      ></app-date-picker>
    </div>
    <div
      class="stats-content-results"
      [class.fade]="pillExpanded"
    >
      <div class="column small">
        <div class="container score">
          <div class="box">
            @if (selectedStat?.interventionText) {
              <div class="markdown-stats scrollable" [innerHTML]="selectedStat?.interventionText ?? '' | markdown | translate : { date: dateMonth }"></div>
            } @else {
              <div class="markdown-stats skeleton">
                @for (i of [1, 2, 3, 4, 5]; track i) {
                  <div class="skeleton-text"></div>
                }
              </div>
            }

            <app-button
              class="button psychologist-services"
              [label]="'WebApp.v1.Shared.Buttons.PsychologistServices' | translate"
              [fontSize]="14"
              [backgroundColor]="primaryColor"
              routerLink="/on-demand"
              [queryParams]="{ type: 'mind' }"
            ></app-button>
          </div>
        </div>
      </div>
      <div class="column big">
        <div class="container">
          <div class="box big">
            @if (selectedUserContext.label === 'WebApp.v1.Stats.Team') {
              <div
                class="box-teams"
                [style.color]="primaryColor"
                (click)="teamsDropdownOpen = !teamsDropdownOpen"
              >
                <i
                  [class]="teamsDropdownOpen ? 'fa-solid fa-xmark' : 'fa-solid fa-chevron-down'"
                  [style.color]="primaryColor">
                </i>
              </div>

              @if (teamsDropdownOpen) {
                <div class="box-teams-dropdown">
                  <div class="box-teams-dropdown-list">
                    @for (team of teams; track team) {
                      <div
                        class="box-teams-dropdown-item"
                        [style.color]="selectedDepartment?.id === team.id ? primaryColor : ''"
                        (click)="onTeamSelected(team)">
                        <div class="box-teams-dropdown-item-text">{{team.name}}</div>
                      </div>
                    }
                  </div>
                </div>
              }
            }
            <div class="box-title">{{ wellbeingTitle | translate: { departmentName: selectedDepartment?.name, companyName: companyName } }}</div>
            <div class="box-date" [style.color]="primaryColor">{{ dateMonth }}</div>
            @if (!isMobile) {
              <div class="box-pill">
                <ng-container *ngTemplateOutlet="overallSpecificToggle"></ng-container>
                <ng-container *ngTemplateOutlet="youTeamToggle"></ng-container>
              </div>
            } @else {
              <ng-container *ngTemplateOutlet="overallSpecificToggle"></ng-container>
            }
            @if (selectedScope.label === 'WebApp.v1.Stats.Specific') {
              <div class="legend">
                @for (legend of specificLegend; track legend) {
                  <div class="legend-item" (click)="onLegendSelected(legend)">
                    <div class="legend-item-color" [style.background-color]="legend.selected ? legend.color : '#B7B7B7'"></div>
                    <div class="legend-item-text" [style.color]="legend.selected ? legend.color : lightModeBlue">{{legend.label | translate}}</div>
                  </div>
                }
              </div>
            }
            <div class="box-chart" [style.marginTop]="selectedScope.label === 'WebApp.v1.Stats.Specific' ? '0px' : '50px'">
              @if (hasData) {
                <app-chart class="chart" [configuration]="configuration"></app-chart>
              } @else {
                <div class="no-data">{{ 'WebApp.v1.Stats.NoData' | translate }}</div>
              }
              @if (selectedScope.label === 'WebApp.v1.Stats.Overall') {
                <div class="barometer"></div>
              }
            </div>
            @if (isMobile) {
              <ng-container *ngTemplateOutlet="youTeamToggle"></ng-container>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="stats-content-footer">
      <div class="stats-content-footer-item">
        <i class="fa-regular fa-lock-keyhole"></i>
        <p class="text">{{ 'WebApp.v1.Stats.EverythingYouDoInHowdyRemainsAnonymous' | translate }}</p>
      </div>
    </div>
  </div>
</div>

<ng-template #overallSpecificToggle>
  <app-toggle
    class="box-toggle"
    [class.hidden]="hideOverallSpecificToggle"
    [color]="primaryColor"
    [options]="scopeOptions"
    (optionSelected)="onOverallSpecificChange($event)"
  ></app-toggle>
</ng-template>

<ng-template #youTeamToggle>
  <app-toggle class="box-toggle" [color]="primaryColor" [options]="userContextOptions" (optionSelected)="onYouTeamChange($event)"></app-toggle>
</ng-template>
